/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The shape of a single change detected during migration.
 * @export
 */
export const MigrationChangeType = {
    AddedSection: 'ADDED_SECTION',
    AddedSubsection: 'ADDED_SUBSECTION',
    AddedElement: 'ADDED_ELEMENT',
    Relabeled: 'RELABELED',
    Reordered: 'REORDERED',
    Removed: 'REMOVED',
    TypeChanged: 'TYPE_CHANGED',
    OptionValueRemoved: 'OPTION_VALUE_REMOVED',
    VisibilityChanged: 'VISIBILITY_CHANGED',
    SpawnTriggerChanged: 'SPAWN_TRIGGER_CHANGED'
} as const;
export type MigrationChangeType = typeof MigrationChangeType[keyof typeof MigrationChangeType];


export function instanceOfMigrationChangeType(value: any): boolean {
    for (const key in MigrationChangeType) {
        if (Object.prototype.hasOwnProperty.call(MigrationChangeType, key)) {
            if (MigrationChangeType[key as keyof typeof MigrationChangeType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MigrationChangeTypeFromJSON(json: any): MigrationChangeType {
    return MigrationChangeTypeFromJSONTyped(json, false);
}

export function MigrationChangeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MigrationChangeType {
    return json as MigrationChangeType;
}

export function MigrationChangeTypeToJSON(value?: MigrationChangeType | null): any {
    return value as any;
}

export function MigrationChangeTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): MigrationChangeType {
    return value as MigrationChangeType;
}

